<template>
    <dl class="cruiseItem" >
        <dt class="cruiseInfo">
            <i class="check_box cruise_check" id="check_box" :class="{ cur: isCruiseSelected}" @click="onCruiseSelected(shoppingCarts)"></i>
            <div class="list_hd">
                <a :href='cruiseLink'>
                    {{cruise.cruiseRoute}}
                </a>
            </div>
            <div class="list_info">
                <div class="info_box">{{cruise.sailDays}}天{{cruise.sailDays-1}}晚 {{ship.shipCNName}}</div>
                <div class="time_box"><span></span>{{sailDateBegin}} - {{sailDateEnd}}</div>
                <a class="add_like cursor-pointer"  @click="onDeleteCruiseClicked(shoppingCart.shipCode, shoppingCart.sailDate, shoppingCart.packageId, shoppingCart.cruiseId)">
                    <i class="detail_ico_18 like_ico"></i>移入收藏夹
                </a>
            </div>
        </dt>
        <ShoppingCartStateroom v-for="(normalStateroom, i) in normalStaterooms"
            :key="('normalStaterooms_'+i)"
            :shoppingCarts="normalStateroom.shoppingCarts"
            :selectedShoppingCarts="normalSelected"
            :onStateroomSelected="onStateroomSelected"
            :onAddShoppingCart="onAddShoppingCart"
            :onDeleteShoppingCart="onDeleteShoppingCart"
            :onDeleteByStateroom="onDeleteByStateroom"
            :showQiaohuPopup="showQiaohuPopup"
            :showStarrySkyPopup="showStarrySkyPopup"
            :showCustomThemePopup="(val)=> showCustomThemePopup(val)"
            :showRow="cruise.isRow"
        />
        <ShoppingCartConnectRoom v-if="connectStaterooms&&connectStaterooms.length == 2"
            :shoppingCarts="connectStaterooms"
            :selectedShoppingCarts="connectSelected"
            :onConnectRoomSelected="onConnectRoomSelected"
            :onDeleteConnectRoom="onDeleteConnectRoom"
            :showConnectRoomPopup="showConnectRoomPopup"
            :showQiaohuPopup="showQiaohuPopup"
            :showStarrySkyPopup="showStarrySkyPopup"
            :showCustomThemePopup="(val)=> showCustomThemePopup(val)"
            :showRow="cruise.isRow"
        />
    </dl>
</template>

<script>
import moment from 'moment'
const ShoppingCartStateroom = () => import('@/components/FloatMenu/ShoppingCartStateroom')
const ShoppingCartConnectRoom = () => import('@/components/FloatMenu/ShoppingCartConnectRoom')
export default {
    name: "ShoppingCartCruise",
    components: {
        ShoppingCartStateroom,
        ShoppingCartConnectRoom
    },
    props: {
        shoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        selectedShoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        onCruiseSelected: {
            type: Function
        },
        onStateroomSelected: {
            type: Function
        },
        onConnectRoomSelected: {
            type: Function
        },
        onAddShoppingCart: {
            type: Function
        },
        onDeleteShoppingCart: {
            type: Function
        },
        onDeleteConnectRoom: {
            type: Function
        },
        onDeleteByStateroom: {
            type: Function
        },
        onDeleteCruiseClicked: {
            type: Function
        },
        showConnectRoomPopup: {
            type: Function
        },
        showQiaohuPopup: {
            type: Function
        },
        showStarrySkyPopup: {
            type: Function
        },
        showCustomThemePopup: {
          type: Function
        }
    },
    methods: {

    },
    computed: {
        cruise() {
            if (this.shoppingCarts && this.shoppingCarts.length > 0) {
                return this.shoppingCarts[0].cruisePartRecord
            }
            return {}
        },
        cruiseLink () {
            return `/Rccl.Cruise/CruiseDetail?sailDate=${this.shoppingCart.sailDate}&shipCode=${this.shoppingCart.shipCode}`
        },
        shoppingCart () {
            if (!this.shoppingCarts || this.shoppingCarts.length == 0) {
                return {}
            }
            return this.shoppingCarts[0]
        },
        ship () {
            return this.cruise.shipPartViewModel || {}
        },
        sailDateBegin () {
            const sailDate = moment(this.cruise.sailDate)
            return sailDate.format('yyyy/MM/DD')
        },
        sailDateEnd () {
            const sailDate = moment(this.cruise.sailDate)
            return sailDate.add(this.cruise.sailDays - 1, 'days').format('yyyy/MM/DD')
        },
        // 非连通房的舱房，数据结构 count: number, categoryCode: 1D, isnrp: false, groupTyp: '' , shoppingCarts: []
        normalStaterooms () {
            const shoppingCarts = this.shoppingCarts.filter(r=>!r.connectId || r.connectId == '')
            let staterooms = []
            shoppingCarts.forEach((shoppingCart) => {
                let stateroom = staterooms.filter(r=>r.categoryCode == shoppingCart.berthedCategoryCode
                && r.isnrp == shoppingCart.isnrp && r.groupType == shoppingCart.groupType)
                if (stateroom && stateroom.length > 0) {
                    stateroom[0].count++
                    stateroom[0].shoppingCarts.push(shoppingCart)
                } else {
                    staterooms.push({
                        count: 1,
                        categoryCode: shoppingCart.berthedCategoryCode,
                        groupType: shoppingCart.groupType,
                        isnrp: shoppingCart.isnrp,
                        shoppingCarts: [shoppingCart]
                    })
                }
            })
            return staterooms
        },
        connectStaterooms () {
            return this.shoppingCarts.filter(r=>r.connectId && r.connectId.length > 0)
        },
        normalSelected () {
            return this.selectedShoppingCarts.filter(r=>!r.connectId || r.connectId == '')
        },
        connectSelected () {
            return this.selectedShoppingCarts.filter(r=>r.connectId && r.connectId.length > 0)
        },
        isCruiseSelected () {
            // 检查航线是否都被选中
            return this.selectedShoppingCarts.length == this.shoppingCarts.length
        }
    }
}
</script>

<style lang="less" scoped>
dl {
    padding: 6px 14px 5px 30px;
    border-bottom: 10px solid #f2f1ed;
    margin-bottom: 5px;
    background: white;
    dt {
        position: relative;
        font-weight: normal;
        min-width: 231px;
        .check_box {
            position: absolute;
            top: 0;
            left: -25px;
            width: 18px;
            height: 18px;
            border: 1px solid #d3dadd;
            border-radius: 2px;
        }
        .check_box.cur {
            background: url(https://resource.rcclchina.com.cn/tui2/list/icon-checkBox-checked.png) no-repeat center;
            border-color: #006ab9;
        }
        .list_hd {
            color: #006ab9;
            font-weight: bold;
            line-height: 1.8;
            margin-bottom: 3px;
        }
        .list_info {
            color: #747d80;
            margin-bottom: 8px;
            .info_box {
                margin-bottom: 5px;
            }
            .time_box {
                margin-bottom: 5px;
                color: #282b2c;
            }
            .cursor-pointer {
                cursor: pointer;
            }
        }
    }
}
</style>
